export default __webpack_public_path__ + "static/media/quote-pink-thanks.15568638.svg";